<template>
  <div class="quantity-wrap">
    <ul class="quantity-digits">
      <li
        v-for="num in 9"
        :key="num"
        @click="handleQuantity(num)"
        :class="['num', chooseQuantity === num ? 'num-is-selected' : '', getCanEdit.quantity ? '' : 'num-is-disabled']"
      >
        {{ num }}
      </li>
      <div
        :class="getCanEdit.quantity ? '' : 'num-is-disabled'"
        style="cursor: pointer"
        @click="openDialog('quantity')"
      >
        ...
      </div>
    </ul>
    <div class="show-quantity">
      數量
      <span>{{ chooseQuantity }}</span>
    </div>
  </div>

  <!-- 計算機彈窗 -->
  <component :is="dialogTemplate"></component>
</template>
<script>
import { useDialog } from '@/utils/dialog';
import { useGetters, useMutations } from '@/utils/mapStore';
import { defineAsyncComponent } from 'vue';

export default {
  name: 'quantity',
  components: {
    Computer: defineAsyncComponent(() => import('@/components/dialog/Computer.vue')),
  },
  setup() {
    //使用彈窗
    const { dialogTemplate, openDialog, closeDialog } = useDialog();
    //取得所選數量
    const { chooseQuantity, getCanEdit } = useGetters('menuItem', ['chooseQuantity', 'getCanEdit']);
    //設定數量
    const SET_QUANTITY = useMutations('menuItem', ['SET_QUANTITY']);
    const handleQuantity = (num) => {
      SET_QUANTITY(num);
      closeDialog();
    };
    return { dialogTemplate, openDialog, chooseQuantity, getCanEdit, handleQuantity };
  },
};
</script>
<style lang="scss" scoped>
.quantity-wrap {
  width: 100%;
  height: 100%;
  display: grid;
  align-items: center;
  grid-template-columns: 4fr 1fr;
  font-size: 2.2rem;
  text-align: center;
  .quantity-digits {
    display: grid;
    grid-template-columns: repeat(10, 10%);
    grid-template-rows: 40px;
  }
  .num {
    width: 40px;
    height: 100%;
    line-height: 40px;
    border-radius: 50%;
    margin: 0 auto;
    transition: 0.2s;
    &-is-selected {
      color: #fff;
      background-color: $color-green;
      border-radius: 50%;
    }
    &-is-disabled {
      cursor: not-allowed;
      opacity: 0.5;
      pointer-events: none;
    }
  }
  .show-quantity span {
    font-size: 3rem;
    padding-left: 10px;
    color: $color-green;
  }
}
</style>
